import { useEffect } from 'react'
import classNames from 'classnames'
import moment from 'moment'
import { withRouter } from 'i18n/utils'
import { withRouteParams } from 'shared/hoc'

import ErrorMessage from 'shared/components/ErrorMessage'
import { DateTimeRange } from 'shared/components/TimePicker'
import { CardSection } from 'shared/components/CardSection'
import Button from 'shared/components/Button'
import withRates from 'shared/hocs/withRates'

import { startOfWeekSelector } from 'settings/selectors'
import { makePurchasePendingSelector } from 'booking/selectors'
import { CARDS } from '../../reducers'
import { searchDateTimeSelector, setDateTimeRange } from 'search-date-time'
import { cancellationSelector, reservationViaUrlSelector } from 'dashboard-transactions/selectors'

import styles from './styles.module.scss'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'
import { FLOW_TYPE_PARK_NOW } from 'analytics/constants'

const DateSelection = ({
    startOfWeek,
    disabledCards,
    makePurchasePending,
    onDateRangeChange,
    ratesError,
    areRatesPending,
    rates,
    range: { start, end },
    enableCard,
    onNext,
    setStartDate,
    existingReservation,
    setDateTimeRange,
    editBookingAmendPolicy,
    isParkNowFlow,
    nonBookable,
}) => {
    const onConfirmBookingTime = () => {
        enableCard([CARDS.AVAILABLE_PRODUCTS, CARDS.SELECT_PARKING_TIME])
    }
    const onNextStep = () => {
        const endTime = end ? end : start.clone().add(1, 'h')
        onConfirmBookingTime()
        onNext()
        setStartDate({
            startDate: start,
            endDate: endTime,
            displayValue: `${start.format('DD-MM-YYYY')} — ${
                end ? end.format('DD-MM-YYYY') : endTime.format('DD-MM-YYYY')
            }`,
        })
    }

    useEffect(() => {
        // editBookingAmendPolicy has 2 default fields which we don't want to remove
        if (Object.keys(editBookingAmendPolicy)?.length > 2) {
            const actualStartTime = moment(existingReservation?.stayFrom)
            const actualEndTime = moment(existingReservation?.stayTo)
            setDateTimeRange(actualStartTime, actualEndTime)
        }
    }, [])

    return (
        <CardSection className={styles.contentSection} loading={false}>
            <h3 className={classNames('text-uppercase', 'font-weight-bold', styles.dateLabel)}>
                <T>booking.purchase.date.label</T>
            </h3>
            {nonBookable && (
                <span className={'font-weight-bold text-brand-primary d-block mb-3'}>
                    <T>booking.date.step.nonbookable.step.description</T>
                </span>
            )}
            <DateTimeRange
                startOptions={{
                    disabled: makePurchasePending === true || isParkNowFlow,
                    datePickerOptions: { label: <T>label.parking.start</T> },
                    timePickerOptions: { label: <T>label.datetime.info</T> },
                }}
                endOptions={{
                    disabled: makePurchasePending === true,
                    datePickerOptions: { label: <T>label.parking.end</T> },
                    timePickerOptions: {
                        label: <T>label.datetime.info</T>,
                    },
                }}
                startOfWeek={startOfWeek}
                start={start}
                end={end}
                onChange={onDateRangeChange}
            />
            {(!disabledCards[CARDS.AVAILABLE_PRODUCTS] && ratesError) ||
                (!areRatesPending && rates.length === 0 && (
                    <ErrorMessage messages={[ratesError ? ratesError : <T>booking.error.rates.not.found</T>]} />
                ))}

            <div className={classNames('row', styles.nextButtonContainer)}>
                <Button size="large" block onClick={onNextStep} className={styles.nextButton}>
                    <T>booking.btn.confirm.booking.time</T>
                </Button>
            </div>
        </CardSection>
    )
}

export default compose(
    withRouter,
    withRouteParams,
    connect(
        createStructuredSelector({
            range: searchDateTimeSelector,
            startOfWeek: startOfWeekSelector,
            makePurchasePending: makePurchasePendingSelector,
            existingReservation: reservationViaUrlSelector,
            editBookingAmendPolicy: cancellationSelector,
        }),
        { setDateTimeRange }
    )
)(withRates(DateSelection))
